<template>
  <div class='recommend-manage atb-flex atb-flex-column'>
    <div class='atb-content-bg atb-flex atb-flex-column'>
      <div class='search'>
        <el-form :inline="true" :model="searchForm" class="atb-input" @keyup.enter.native.prevent="getList(1)" @submit.native.prevent>
          <div class="query-where">
            <el-form-item class="flex-form-item" label="部门名称" prop="departmentNo">
              <el-popover
                placement="bottom-start"
                width="420"
                popper-class="popper-tree declare-dep"
                @hide="handledHide"
                trigger="click">
                <el-tree
                  :props="defaultProps"
                  :data="treeData"
                  show-checkbox
                  node-key='id'
                  ref="tree"
                  highlight-current
                  :default-expanded-keys="expandedData"
                  @check="handleCheckChange"
                >
                </el-tree>
                <el-input slot="reference" v-model="department" placeholder="请选择部门" clearable></el-input>
              </el-popover>
            </el-form-item>
            <el-form-item class="flex-form-item" label="上级">
              <selecter v-model="searchForm.superiorNo" placeholder="输入工号或姓名查询"></selecter>
            </el-form-item>
            <el-form-item class="flex-form-item" label="姓名">
              <selecter v-model="searchForm.reWkName" placeholder="输入工号或姓名查询"></selecter>
            </el-form-item>
            <el-form-item class="flex-form-item" label="建议人">
              <selecter v-model="searchForm.wkName" placeholder="输入工号或姓名查询"></selecter>
            </el-form-item>
            <el-form-item class="flex-form-item" label="建议评级">
              <el-select clearable v-model="searchForm.ratingResult" placeholder="建议评级">
                <el-option v-for="item in oecLevel" :key="item.value" :label="item.label" :value="item.label"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="query-operation">
            <el-form-item class="flex-form-item" label="月份">
              <el-date-picker
                v-model="searchForm.month"
                type="month"
                value-format="yyyy-MM"
                placeholder="选择月">
              </el-date-picker>
            </el-form-item>
            <el-form-item class="flex-form-item" label="建议状态">
              <common-select ref="status" v-model="searchForm.status" :list="statusList" optLabel="itemDesc" optValue="itemValue" placeholder="建议状态" clearable></common-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getList(1)" v-if="$auth(that, 'Details')">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="export" @click="declareRemind" v-if="$auth(that, 'Manage')">申报提醒</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="export" @click="exportExcel" v-if="$auth(that, 'Details')">导出</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="downloadTemplate" @click="batchExport" v-if="$auth(that, 'Details')">批量导出</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="export" @click="resultPush" v-if="$auth(that, 'Manage')">结果推送</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class='table-content'>
        <vxe-table
          stripe
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          auto-resize
          resizable
          highlight-hover-row
          :data="tableData"
          ref="unHandle"
          @cell-click="expandRow"
          :seq-config="{seqMethod}"
        >
          <vxe-table-column type="seq" width="60" title="NO."></vxe-table-column>
          <vxe-table-column field="reWkNo" width="150" title="姓名">
             <template #default="{ row }">
              <span>{{row.reWkName? row.reWkName + "("+row.reWkNo+")": row.reWkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="wkNo" title="建议人" width="150">
            <template #default="{ row }">
              <span>{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="superiorNo" width="150" title="上级">
            <template #default="{ row }">
              <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="department" title="部门" width="220"></vxe-table-column>
          <vxe-table-column field="date" title="年/月" width="80">
            <template #default="{row}">{{row.year + '/' + row.month}}</template>
          </vxe-table-column>
          <vxe-table-column width="90" field="ratingResult" title="建议评级" :edit-render="{name: 'ElSelect', autofocus: '.el-input__inner'}">
            <template #default="{row}">
              <span v-if="row.ratingResult == 'A'" style="color:#22b6a1">{{row.ratingResult}}</span>
              <span v-else-if="row.ratingResult == 'B'">{{row.ratingResult}}</span>
              <span v-else style="color:#fe6562">{{row.ratingResult}}</span>
            </template>
            <template #edit="{row}">
              <el-select v-model="row.ratingResult" @change="$refs.unHandle.updateStatus(scope)">
                <el-option v-for="item in oecLevel" :key="item.label" :label="item.label" :value="item.label"></el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column width="110" field="importanceLevel" title="重要性" :edit-render="{name: 'ElSelect', autofocus: '.el-input__inner'}">
            <template #default="{row}">
              <span>{{formatImportance(row.importanceLevel)}}</span>
            </template>
            <template #edit="{row}">
              <el-select v-model="row.importanceLevel" @change="$refs.unHandle.updateStatus(scope)">
                <el-option v-for="item in importanceList" :key="item.itemValue" :label="item.itemDesc" :value="item.itemValue"></el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column min-width="160" field="ratingReason" title="建议原因" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.ratingReason"></el-input>
            </template>
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.ratingReason}}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remarks" width="150" title="备注" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.remarks"></el-input>
            </template>
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.remarks}}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="建议状态" width="95" align="center">
            <template #default="{ row }">
              <el-tag :type="row.status == 0 ? 'unstart' : (row.status == 1 ? 'complete' : 'ongoing') " effect="dark">
                {{ formatStatus(row.status) }}
              </el-tag>
            </template>
          </vxe-table-column>
          <vxe-table-column width="200" field="oecRatingResult" title="OEC结果">
            <template #default="{row}">
              <div v-if="row.oecEntity" :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">
                <span>
                  <span v-if="row.oecEntity.ratingResult == 'A'" style="color:#22b6a1">{{row.oecEntity.ratingResult}}</span>
                  <span v-else-if="row.oecEntity.ratingResult == 'B'">{{row.oecEntity.ratingResult}}</span>
                  <span v-else style="color:#fe6562">{{row.oecEntity.ratingResult}}</span>
                </span>
                <el-tag class="oec-result-status" :type="row.oecEntity.status == 0 ? 'unstart' : (row.oecEntity.status == 1 ? 'complete' : 'ongoing') " effect="dark">
                  {{ formatOecStatus(row) }}
                </el-tag>
                <span>{{ row.oecEntity.ratingReason }}</span>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="" title="操作" fixed="right" width='100' class-name='operation'>
            <template #default="scope">
              <div>
                <el-tooltip class='item' effect='dark' content='编辑' placement="bottom" v-if="$auth(that, 'Manage')">
                  <i class='icon-editor' @click.stop='edit({row:scope.row})'></i>
                </el-tooltip>
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class='page-con atb-flex atb-flex-justify-end'>
        <vxe-pager
          background
          :current-page.sync="page.PageIndex"
          :page-size.sync="page.PageSize"
          :total="total"
          height="100%"
          @page-change="pageChange"
          :page-sizes="[10, 30, 50, 100, 500]"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes', 'Total']"
        >
        </vxe-pager>
      </div>
    </div>
    
    <common-dialog ref="addDialog" :title="dialogContent.title" width="720px" showClose :appendBody="true">
      <template slot="content">
        <component v-bind:is="dialogContent.componentName" :editData="EditRow" :importanceList="importanceList" :param="Object.assign({}, this.searchForm, { departmentNo: this.departmentNo })" @submitSuccess="getList()"></component>
      </template>
    </common-dialog>
    <common-dialog ref="exportDialog" title="日期范围选择" width="540px" showClose :appendBody="true">
      <template slot="content">
        <BatchExport :param="exportParams" />
      </template>
    </common-dialog>
    <el-dialog title="提示" :visible.sync="showResultPushDialog" width="360px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2 style="line-height: 1.5;">是否确认推送？</h2>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="confirmResultPush()">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showResultPushDialog = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import _ from 'lodash';
  export default {
    components: {
      add:()=>import('./add.vue'),
      selecter:()=>import('@/component/global/customerSelect'),
      DeclareRemind: ()=>import('./DeclareRemind'),
      BatchExport: ()=>import('./BatchExport'),
    },
    name: "RecommendManage",
    data() {
      const ratingReasonValid = ({cellValue,row}) => {
        if (!cellValue && ['A', 'C'].includes(row.ratingResult)) {
          return new Error('评级结果为A、C时必须填写原因！')
        }
      }
      return {
        validRules: {
          ratingReason: [
            { validator: ratingReasonValid }
          ]
        },
        oecLevel: [
          {label: 'A'},
          {label: 'B'},
          {label: 'C'},
        ],
        searchForm: {
          reWkName: '',
          wkName: '',
          ratingResult: '',
          superiorNo: '',
          month: null,
          status: '',
        },
        seleterData: {},
        page: {
          PageIndex: 1,
          PageSize: 10
        },
        total: 0,
        tableData: [],
        unHandleList: [],
        statusList:[],
        that: this,
        depData: [],
        treeData: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        depList:[],
        department:'',
        copyTreeData:[],
        departmentNo:'',
        expandedData:[],
        dialogContent:{},
        selectNode: [],
        importanceList: [],
        oecStatusList: [],
        currWkNo: '',

        showResultPushDialog: false,
      }
    },
    computed: {
      exportParams() {
        return {
          ...this.searchForm,
          loginWkNo: this.currWkNo,
          departmentNo: this.departmentNo
        }
      }
    },
    created() {
      this.getList();
      const userInfo = sessionStorage.getItem('userInfo');
      this.currWkNo = userInfo ? JSON.parse(userInfo).wkNo : '';
    },
    mounted() {
      this.getImportanceList();
      this.getOecStatus();
      this.getStatus();
      this.getDep();
      this.getSimpleCheckedNodes(this.$refs.tree.store);
    },
    methods: {
      // 格式化序列号
      seqMethod({ rowIndex }) {
        return rowIndex + (this.page.PageIndex - 1) * this.page.PageSize + 1;
      },
      formatStatus(status) {
        const item = this.statusList.find(t => t.itemValue == status);
        return item ? item.itemDesc : '';
      },
      getImportanceList() {
        this.$ajax.get(this.$api.common.getDict, {ItemType: 'OECRecommendImportance'}).then((res) => {
          this.importanceList = res.data.rows || res.data || [];
        });
      },
      formatImportance(importance) {
        let res = this.importanceList.find(t => t.itemValue == importance)
        return res ? res.itemDesc : '';
      },

      getOecStatus() {
        this.$ajax.get(this.$api.common.getDict, {ItemType: 'OecStatus'}).then((res) => {
          this.oecStatusList = res.data.rows || res.data || [];
        });
      },
      formatOecStatus(row) {
        const oecData = row.oecEntity || {};
        let status = this.oecStatusList.find(t => t.itemValue == oecData.status)
        return status ? status.itemDesc : '';
      },
      getSelecterData(data){
        this.seleterData = data;
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      async getList(resetPage) {
        if(resetPage){
          this.page.PageIndex = 1;
        }
        let param = Object.assign({}, this.page, this.searchForm, {departmentNo: this.departmentNo});
        await this.$ajax.get(this.$api.manage.recommendManage.list, param).then((res) => {
          this.tableData = res.data.rows || [];
          this.total = res.data.total;
        });
      },
      save() {
        if (this.unHandleList.length) {
          this.$ajax.post(this.$api.manage.declare.createAll, this.unHandleList).then(() => {
            this.$message.success("保存成功");
          });
        } else {
          this.$ajax.post(this.$api.manage.declare.createAll, this.tableData).then(() => {
            this.$message.success("保存成功");
          });
        }
      },
      unHandleSelectAll({records}) {
        this.unHandleList = records;
      },
      unHandleSelectChange({records}) {
        this.unHandleList = records;
      },
      pageChange({ currentPage }) {
        this.page.PageIndex = currentPage;
        this.getList();
      },
      async getStatus(){
        await this.$ajax.get(this.$api.common.getDict, {ItemType:'OECRecommendDeclare'}).then((res) => {
          this.statusList = res.data.rows||res.data||[];
        });
      },
      // eslint-disable-next-line no-unused-vars
      expandRow({row, rowIndex}) {
        this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
        this.$refs.unHandle.updateData(this.tableData);
      },
      async getDep() {
       await this.$ajax.get(this.$api.Identity.Categord.dep, {}).then(res => {
          this.depList=res.data||[];     
            const obj ={};
            this.depList.forEach(v=>{
             const objClone=_.cloneDeep(obj);
             objClone.id= v.id,
             objClone.code= v.code,
             objClone.label= v.displayName
           if(v.parentId === null){
              this.expandedData.push(v.id);
              objClone.children= this.depList.filter(t=>t.parentId===v.id);
              this.generateMenu(objClone.children);
              this.treeData.push(objClone);
              this.copyTreeData=_.cloneDeep(this.treeData);
            }
          });
        });
      },
      generateMenu(chs){
        chs.forEach(v=>{
          v.label= v.displayName
          v.children = this.depList.filter(t=>t.parentId === v.id)
          this.generateMenu(v.children);
        });
      },
      getSimpleCheckedNodes(store) {
        const checkedNodes = [];
        const traverse = function(node) {
          const childNodes = node.root ? node.root.childNodes : node.childNodes;
          childNodes.forEach(child => {
            if (child.checked) {
              checkedNodes.push(child.data);
            }
            if (child.indeterminate) {
              traverse(child);
            }
          });
        };
        traverse(store)
        return checkedNodes;
      },
      handleCheckChange(data, checked){
        this.selectNode = this.getSimpleCheckedNodes(this.$refs.tree.store);
        let code = [] , deptNmae = [];
        this.selectNode.forEach(t => {
          code.push(t.code);
          deptNmae.push(t.label);
        });
        this.departmentNo = code.join(",");
        this.department = deptNmae.join(",");
      },
      getChildrenMenu(depData){
        let depTree=[];
        depData.forEach(t => {
          if(t.label.indexOf(this.department) != -1){
            depTree.push(t)
          }else{
            if(t.children && t.children && t.children.length){
              t.children = this.getChildrenMenu(t.children)
              if(t.children && t.children.length){
                depTree.push(t)
              }
            }
          }
        });
        return this.treeData=depTree;
      },
      handledHide(){
        this.$nextTick(() => {
          if(!this.$refs.tree.getCheckedKeys().length){
            this.department = "";
          }
        });
      },
      edit({row}) {
        this.EditRow = typeof(row) == 'object' ? row || {} : {};
        if (this.EditRow.importanceLevel) {
          this.EditRow.importanceLevel = '' + this.EditRow.importanceLevel;
        }
        this.dialogContent = {
          title: '编辑',
          componentName: 'add'
        }
        this.$refs.addDialog.show();
      },

      declareRemind() {
        this.dialogContent = {
          title: '提醒人员确认',
          componentName: 'DeclareRemind',
          width: '720px'
        }
        this.$refs.addDialog.show()
      },
      exportExcel() {
        let param = Object.assign({}, this.searchForm, {departmentNo: this.departmentNo});
        this.$ajax.get(this.$api.manage.recommendManage.exportFile, param, {ignore: true, responseType: 'blob'}).then((res) => {
          if (res.data.type == 'application/json') {
            var reader = new FileReader();
            reader.onload = () => {
              var content = reader.result;//内容就在这里
              let json = JSON.parse(content)
              this.$message.error(json.message)
            };
            reader.readAsText(res.data);
          } else {
            const filename = 'OEC建议管理'
            const filetype = 'xlsx'
            let data = res.data;
            let url = window.URL.createObjectURL(data)
            let a = document.createElement('a')
            document.body.appendChild(a)
            a.href = url
            a.download = filename + '.' + filetype
            a.click()
            window.URL.revokeObjectURL(url)
          }
        });
      },
      batchExport(){
        this.$refs.exportDialog.show();
      },

      resultPush() {
        this.showResultPushDialog = true;
      },
      confirmResultPush() {
        let param = Object.assign({}, this.page, this.searchForm, {departmentNo: this.departmentNo});
        this.$ajax
          .get(this.$api.manage.recommendManage.resultPush, param)
          .then((res) => {
            if (res.code === 0) {
              this.$router.push({
                path: '/manage/export-task/index',
              });
            }
          });
      }
    },
    watch:{
      department:{
        handler(val){
            // const depTree=_.cloneDeep(this.copyTreeData);
            // this.getChildrenMenu(depTree);
          if(!val){
            this.departmentNo="";
            this.$refs.tree&&this.$refs.tree.setCheckedKeys([]);
          }  
        },
        immediate:true
      }
    }
  }
</script>
<style scoped lang='scss'>
  .recommend-manage {
    .search {
      .atb-input{
        display: flex;
        flex-direction: column;
        .query-where{
          display: flex;
          .flex-form-item{
            display: flex;
            flex: 1;
            margin-bottom: 12px;
          }
          ::v-deep.el-form-item__content{
            flex: 1;
            .el-select, .el-autocomplete, .el-date-editor{
              width: 100%;
            }
          }
        }
        .query-operation {
          display: flex;
          flex-wrap: wrap;
          .flex-form-item {
            display: flex;
            flex: 1;
            max-width: 300px;
          }
          ::v-deep.el-form-item__label {
            white-space: nowrap;
          }
          ::v-deep.el-form-item__content{
            flex: 1;
            .el-select, .el-autocomplete, .el-date-editor {
              width: 100%;
            }
            .el-date-editor {
              min-width: 120px;
            }
            .el-select {
              min-width: 80px;
            }
          }
        }
      }
     
    }
    height: 100%;
    .atb-content-bg {
      margin-top: 15px;
      padding: 20px;
      flex: 1;
    }
    ::v-deep .tab{
      margin-top: -3px;
    }
    ::v-deep .el-dialog__body{
      padding-top: 33px !important;
      text-align: center;
      h2{
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p{
        color: $--color-text-regular;
      }
    }
    .oec-result-status {
      margin: 0 10px;
    }
    ::v-deep .el-dialog__footer{
      text-align: center;
    }
  }
</style>
<style>
  .declare-dep{
    height: 350px;
    width: 350px;
    overflow: auto;
  }
</style>